import { render, staticRenderFns } from "./pipe-detail.vue?vue&type=template&id=5a0db403&scoped=true"
import script from "./pipe-detail.vue?vue&type=script&lang=js"
export * from "./pipe-detail.vue?vue&type=script&lang=js"
import style0 from "./pipe-detail.vue?vue&type=style&index=0&id=5a0db403&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0db403",
  null
  
)

export default component.exports